<template>
  <div class="block_wrap">

    <div class="line">
<!--      <div class="input_wrap parent_company">-->
<!--        <label>-->
<!--          {{ translate('project.client') }}-->
<!--        </label>-->
<!--        <tree-select-->
<!--            :options="client_list"-->
<!--            :placeholder="translate('project.client')"-->
<!--            v-model="main_info.client_id"-->
<!--            :clearable="false"-->
<!--            :multiple="false"-->
<!--            :disabled="check_client_id"-->
<!--        />-->
<!--      </div>-->

      <div class="input_wrap main_name" v-if="main_info.id">
        <fg-input
            v-model="main_info.responsible_user"
            type="text"
            :label="translate('project.responsible_user')"
            :readonly="true"
        />
      </div>

      <div class="input_wrap main_name" v-if="main_info.id">
        <fg-input
            v-model="main_info.manager_user"
            type="text"
            :label="translate('project.manager_user')"
            :readonly="true"
        />
      </div>
    </div>

    <div class="line" v-if="main_info.ts_update" >
      <div class="input_wrap">
        <p>
          {{ translate('project.updated') }}:
          {{ get_date(main_info.ts_update) }}
        </p>
      </div>

      <div class="input_wrap">
        <p>
          {{ translate('project.created') }}:
          {{ get_date(main_info.ts_create) }}
        </p>
      </div>

      <div class="input_wrap">
        <p v-if="main_info.create_user !== ''">
          {{ translate('project.create_username') }}:
          {{ main_info.create_user }}
        </p>
      </div>
    </div>

    <div class="line" v-if="has_changes">
      <div class="button_wrap">
        <button
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="edit_projects"
        >
          {{ translate('btn.edit') }}
        </button>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  name: 'MainInfo',
  props: ['project'],

  data () {
    return {
      main_info: {},
      new_status: this.project.status !== null ? this.project.status : 0,
      new_priority: this.project.priority !== null ? this.project.priority : 0
    }
  },
  computed:{
    check_client_id(){
      return this.main_info.id !== null
    },

    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return {label: client.name, id: client.id}
      })
    },

    status_list(){
      return this.$store.getters.getProjectInfo.statuses.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
    },

    priority_list(){
      return this.$store.getters.getProjectInfo.prioritys.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
    },

    has_changes(){
      // поля из выпадающих списков
      this.main_info.status = this.new_status
      this.main_info.priority = this.new_priority
      let main_info = Object.assign({}, this.main_info)
      let project_info = Object.assign({}, this.project)

      return JSON.stringify(main_info) !== JSON.stringify(project_info)
    }
  },
  created() {
    this.main_info = Object.assign({}, this.project)
  },
  watch:{
    project(){
      this.main_info = Object.assign({}, this.project)
    },
  },
  methods: {
    cancel () {
      this.$emit('close')
    },

    edit_projects(){
      if (this.main_info?.id){
        this.$http.v1.updateProject(this.main_info.id, this.main_info, (response) => {
          this.$emit('update_project', response.data.project)
          this.global_notify('info', this.translate('project.saved_success'))
        })
      }else{
        this.$http.v1.createProject(this.main_info, (response) => {
          this.$emit('update_project', response.data.project)
          this.global_notify('info', this.translate('project.saved_success'))
        })
      }
    }
  }
}

</script>

<style lang='scss' scoped>
.block_wrap{
  text-align: left;
  .line{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    text-align: left;
    margin-bottom: 10px;
    .filter{
      min-width: 100px;
      text-align: center;
      margin: 0;
    }
    .form-group{
      margin: 0;
    }
    .text_wrap{
      width: 50%;
      margin: 2.5px;
    }
    .input_wrap{
      width: 50%;
      margin: 2.5px;
      &.main_name{
        width: 100%;
      }
      &.parent_company{
        width: 100%;
        .vue-treeselect{
          margin-bottom: 0;
        }
      }
      .vue-treeselect{
        margin-bottom: 0;
      }
    }

    .button_wrap{
      width: 100%;
      text-align: right;
    }
  }
}

textarea{
  resize: both;
}

</style>

